/* eslint-disable no-undef */
import Flex from '@deprecated-ui/common/Flex';
import Notation from 'global/Notation';
import CorpActionTag from 'global/CorpAction/CorpActionTag';
import Badge from 'global/Badges';
import { CSSProperties } from 'react';

interface CompanyProps {
  symbol: string;
  symbol_2?: string;
  uma: boolean;
  notation: Array<any>;
  corp_action: Record<string, any>;
  status?: any;
  [key: string]: any;
}

const compareValue = (value, otherValue) => !!value || !!otherValue;

/**
 * Render tags notation and corp action
 */
const renderTags = (
  company: CompanyProps,
  showPopover = true,
  placement = 'top',
  customContainerStyle: CSSProperties | null = {
    marginLeft: 4,
    gap: 4,
  },
) => {
  const {
    symbol,
    symbol_2,
    notation = [],
    corp_action = {},
    uma,
    name: companyName,
    withNotation = 0,
    withUMA = 0,
    withCorpAction = 0,
    status = 0,
  } = company;

  const companySymbol = symbol || symbol_2;
  const showNotation = compareValue(notation?.length > 0, withNotation);
  const showCorpAction = compareValue(corp_action?.active, withCorpAction);
  const showUma = compareValue(uma, withUMA);
  const showBadge = status !== 0;

  if (!showBadge && !showCorpAction && !showNotation && !showUma) {
    return <></>;
  }

  return (
    <Flex align="center" style={customContainerStyle}>
      {/* Should only shown if company has notsus */}
      {showNotation && (
        <Notation
          symbol={companySymbol}
          name={companyName}
          notation={notation}
          uma={false}
          isPopover={showPopover}
          isNotationBadges
          placement={placement}
        />
      )}
      {showCorpAction && (
        <CorpActionTag corpAction={company.corp_action} isCorpActionBadges />
      )}
      {showBadge && <Badge status={status} />}
      {/* Separate UMA from notsus */}
      {showUma && (
        <Notation
          symbol={companySymbol}
          name={companyName}
          notation={notation}
          uma={showUma}
          isNotationBadges
          type="uma"
          placement={placement}
          isPopover={false}
        />
      )}
    </Flex>
  );
};

// eslint-disable-next-line import/prefer-default-export
export { renderTags };
